import * as yup from 'yup';
import { t } from 'i18next';

export const mlConfigurationSchema = yup.object().shape({
  mainCount: yup
    .number()
    .integer()
    .required()
    .min(0)
    .max(5, () =>
      t('forms.errors.string.positiveIntegerLTOrEqualToMaxValue', {
        fieldName: t(
          'page.menus.recommendations.settings.mainCountInput.label',
        ),
        maxValue: 5,
      }),
    )
    .flexDefault('')
    .typeError(() => t('forms.errors.mixed.required')),
  sideCount: yup
    .number()
    .integer()
    .required()
    .min(0)
    .max(5, () =>
      t('forms.errors.string.positiveIntegerLTOrEqualToMaxValue', {
        fieldName: t(
          'page.menus.recommendations.settings.sideCountInput.label',
        ),
        maxValue: 5,
      }),
    )
    .flexDefault('')
    .typeError(() => t('forms.errors.mixed.required')),
  beverageCount: yup
    .number()
    .integer()
    .required()
    .min(0)
    .max(5, () =>
      t('forms.errors.string.positiveIntegerLTOrEqualToMaxValue', {
        fieldName: t(
          'page.menus.recommendations.settings.beverageCountInput.label',
        ),
        maxValue: 5,
      }),
    )
    .flexDefault('')
    .typeError(() => t('forms.errors.mixed.required')),
  dessertCount: yup
    .number()
    .integer()
    .required()
    .min(0)
    .max(5, () =>
      t('forms.errors.string.positiveIntegerLTOrEqualToMaxValue', {
        fieldName: t(
          'page.menus.recommendations.settings.dessertCountInput.label',
        ),
        maxValue: 5,
      }),
    )
    .flexDefault('')
    .typeError(() => t('forms.errors.mixed.required')),
  maxRuleRecommendations: yup
    .number()
    .integer()
    .required()
    .min(0)
    .max(10, () =>
      t('forms.errors.string.positiveIntegerLTOrEqualToMaxValue', {
        fieldName: t(
          'page.menus.recommendations.settings.maxRuleRecommendations.label',
        ),
        maxValue: 10,
      }),
    )
    .flexDefault('')
    .typeError(() => t('forms.errors.mixed.required')),
  maxRecommendations: yup
    .number()
    .integer()
    .required()
    .min(0)
    .max(10, () =>
      t('forms.errors.string.positiveIntegerLTOrEqualToMaxValue', {
        fieldName: t('page.menus.recommendations.settings.maxCountInput.label'),
        maxValue: 10,
      }),
    )
    .flexDefault('')
    .typeError(() => t('forms.errors.mixed.required')),
  locationIds: yup
    .array()
    .of(
      yup.object().shape({
        id: yup.string().required(),
        label: yup.string().required(),
      }),
    )
    .default([]),
});
